import { render, staticRenderFns } from "./cp_copy_right.vue?vue&type=template&id=81cb14be&scoped=true"
import script from "./cp_copy_right.vue?vue&type=script&lang=js"
export * from "./cp_copy_right.vue?vue&type=script&lang=js"
import style0 from "./cp_copy_right.vue?vue&type=style&index=0&id=81cb14be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cb14be",
  null
  
)

export default component.exports